<template>
  <v-app dark>

    <!-- Toolbar Web -->
    <v-toolbar v-if="$vuetify.breakpoint.mdAndUp" fixed class="elevation-0" :color="toolColor">
      <!-- Language Buttons -->
      <v-flex md2 lg3>
        <v-layout row wrap align-center>
          <v-flex xs2 @click="language = 'fi'">
            <img src="public/icons/suo.png" class="flags icon-transform-1">
          </v-flex>
          <v-flex xs2 @click="language = 'sv'">
            <img src="public/icons/sve.png" class="flags icon-transform-1">
          </v-flex>
          <v-flex xs2 @click="language = 'en'">
            <img src="public/icons/eng.png" class="flags icon-transform-1">
          </v-flex>
        </v-layout>     
      </v-flex>
      <!-- Page Links -->
      <v-flex md8 lg6>
        <v-layout align-center justify-center>
          <v-flex v-for="item in pagelinks" :key="item.title" class="text-xs-center">
            <router-link :to="item.route" class="font-subheading pageLinks" :style="{ 'color':pageLinkSel(item.route)}">
              <v-flex v-if="language == 'en'">
                {{item.en}}
              </v-flex>
              <v-flex v-else-if="language == 'fi'">
                {{item.fi}}
              </v-flex>
              <v-flex v-else-if="language == 'sv'">
                {{item.sv}}
              </v-flex>
            </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Log In Button -->
      <v-flex md2 lg3 class="text-xs-right">
        <v-btn round class="success" v-bind:href="'http://www.clients.ewvirtual.fi'">
          <a class="white--text" v-lang.login></a>
        </v-btn>
      </v-flex>
    </v-toolbar>

    <!-- Toolbar Mobile -->
    <v-toolbar v-else fixed class="elevation-0" :color="toolColor">
      <v-btn class="ml-1" icon fab @click.stop="drawer = !drawer" elevation-10>
        <v-icon>menu</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="mobileStyle">{{getTitle}}</v-toolbar-title>
    </v-toolbar>

    <!-- Side Menu Mobile -->
    <v-navigation-drawer v-if="$vuetify.breakpoint.mdAndDown" :disable-resize-watcher="false" temporary :mini-variant="false" left clipped fixed v-model="drawer" class="black mb-0 pb-0">
      <v-layout row wrap align-center justify-center>
        <!-- Close Button -->
        <v-flex xs6 class="text-xs-left">
          <v-btn icon @click="drawer= false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-flex>
        <!-- Log In Button -->
        <v-flex xs6 class="text-xs-right">
          <v-btn round class="mt-2 ml-2 success" v-bind:href="'http://www.clients.ewvirtual.fi'">
            <a class="white--text" v-lang.login></a>
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- Items List -->
      <v-list id="titleList" class="mt-5 pt-5">
        <v-list-tile v-for="item in pagelinks" :key="item.en">
          <router-link :to="item.route" class="pageLinks mx-auto" :style="{ 'color':pageLinkSel(item.route)}">
            <v-list-tile-content class="mobileStyle">
              <v-list-tile-title v-if="language == 'en'">{{ item.en }}</v-list-tile-title>
              <v-list-tile-title v-else-if="language == 'fi'">{{ item.fi }}</v-list-tile-title>
              <v-list-tile-title v-else-if="language == 'sv'">{{ item.sv }}</v-list-tile-title>
            </v-list-tile-content>
          </router-link>
        </v-list-tile>
      </v-list>
      <!-- Language Buttons -->
      <v-layout row wrap align-center>
        <v-flex xs3></v-flex>
        <v-flex xs2 @click="language = 'fi'" class="text-xs-center">
          <img src="public/icons/suo.png" class="flags icon-transform-1">
        </v-flex>
        <v-flex xs2 @click="language = 'sv'" class="text-xs-center">
          <img src="public/icons/sve.png" class="flags icon-transform-1">
        </v-flex>
        <v-flex xs2 @click="language = 'en'" class="text-xs-center">
          <img src="public/icons/eng.png" class="flags icon-transform-1">
        </v-flex>
        <v-flex xs3></v-flex>
      </v-layout>
      <!-- EW Logo  -->
      <v-container>
        <v-flex xs12 class="text-xs-center">
          <img src="public/icons/EW_logo_min.png">
        </v-flex>
      </v-container>
    </v-navigation-drawer>

    <!-- Scroll Button -->
    <v-layout v-if="scrollEnable">
      <v-btn fab color="red" @click="scrollWindowUp()" :class="btnStyle">
        <v-icon>expand_less</v-icon>
      </v-btn>
    </v-layout>

    <!-- Content Pages -->
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: false,
      scrollEnable: false,
      btnStyle: "",
      toolColor: "transparent",
      pagelinks: [
        {
          en: "Home",
          fi: "Etusivu",
          sv: "Hem",
          route: "Home"
        },
        {
          en: "EW Virtual",
          fi: "EW Virtual",
          sv: "EW Virtual",
          route: "Virtual"
        },
        {
          en: "Web Manager",
          fi: "Web Manager",
          sv: "Web Manager",
          route: "Web"
        },
        {
          en: "EW System",
          fi: "EW System",
          sv: "EW System",
          route: "System"
        },
        {
          en: "Cases",
          fi: "Toteuksia",
          sv: "Exempel",
          route: "Cases"
        },
        {
          en: "Pricing",
          fi: "Hinnasto",
          sv: "Priserna",
          route: "Pricing"
        },
        {
          en: "Contact",
          fi: "Yhteystiedot",
          sv: "Kontakt",
          route: "Contact"
        }
      ]
    };
  },
  methods: {
    pageLinkSel: function(link) {
      if (this.$route.path.substr(1) === link) {
        return "grey";
      } else {
        return "white";
      }
    },
    scrollWindowUp: function() {
      window.scrollBy({
        top: -10000,
        behavior: "smooth"
      });
    }
  },
  computed: {
    getTitle: function() {
      let x = this.pagelinks.find(link => {
        return link.route === this.$route.path.substr(1);
      });
      if (x.en === "Home") {
        return "";
      } else {
        return x[this.language];
      }
    }
  },



  mounted() {
     let self = this;  
    // Scroll Processing
    this.windowScroll = window;
    this.windowScroll.onscroll = function() {
      if (self.windowScroll.scrollY > 0) {
        self.scrollEnable = true;
        self.btnStyle = "scrollBtnIn";
      } else {
        self.btnStyle = "scrollBtnOut";
        setTimeout(() => {
          self.scrollEnable = false;
        }, 200);
      }
    };
  },
  updated() {
    if (this.$route.path.substr(1) === "Home") {
      this.toolColor = "transparent";
    } else {
      this.toolColor = "dark";
    }
  }
};
</script>

<style>
.pageLinks {
  color: white;
  text-decoration: none;
}

.pageLinks:hover {
  color: grey;
}

.mobileStyle {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: lighter;
  font-size: 2em;
}

#titleList .list__tile {
  height: 50px !important;
}

#titleList .list__tile__title {
  height: 100% !important;
  line-height: normal !important;
}

.scrollBtnIn {
  position: fixed;
  bottom: 16px;
  right: 8px;
  z-index: 2;
  animation: createBtn 0.25s;
}

.scrollBtnOut {
  position: fixed;
  bottom: 16px;
  right: 8px;
  z-index: 2;
  animation: destroyBtn 0.25s;
}

@keyframes createBtn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

@keyframes destroyBtn {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue